import { isAxiosError } from "axios";

const RETRYABLE_NETWORK_ERROR_CODES = new Set(["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"]);

export function isRetryableNetworkError(error: unknown): boolean {
  if (isAxiosError(error)) {
    return (
      !error.response &&
      ((error.code !== undefined && RETRYABLE_NETWORK_ERROR_CODES.has(error.code)) ||
        error.message.includes("Network Error") ||
        error.message.includes("timeout"))
    );
  }

  return (
    error instanceof Error &&
    (error.message.includes("Network Error") ||
      error.message.includes("ERR_NETWORK") ||
      error.message.includes("timeout"))
  );
}
